import { Card } from '../components/Card';
import { MetricRow } from '../components/MetricRow';
import { ScoreRing } from '../components/ScoreRing';
import { SleepStageBar } from '../components/SleepStageBar';
import { useHealthData } from '../services/HealthDataContext';
import { getMetricSeries } from '../services/metrics';
import { formatMinutesAsHours, formatTime } from '../services/labels';

export function SleepScreen() {
  const { today, todayKey, scores, baselines, historyByDate } = useHealthData();
  const durationSeries = getMetricSeries(historyByDate, 'sleepDuration', todayKey, 14).map((p) => p.value);
  const efficiencySeries = getMetricSeries(historyByDate, 'sleepEfficiency', todayKey, 14).map((p) => p.value);
  const deepSeries = getMetricSeries(historyByDate, 'deepSleep', todayKey, 14).map((p) => p.value);
  const remSeries = getMetricSeries(historyByDate, 'remSleep', todayKey, 14).map((p) => p.value);

  return (
    <div className="screen screen--sleep">
      <div className="screen__score-header">
        <ScoreRing score={scores.sleepScore} label="Sueno" size={140} />
        <div className="screen__score-summary">
          <p className="screen__score-summary-title">{formatMinutesAsHours(today.sleep.totalMinutes)}</p>
          <p className="screen__score-summary-subtitle">
            {formatTime(today.sleep.bedtime)} - {formatTime(today.sleep.wakeTime)}
          </p>
        </div>
      </div>

      <Card title="Fases de sueno">
        <SleepStageBar
          deepMinutes={today.sleep.deepMinutes}
          remMinutes={today.sleep.remMinutes}
          coreMinutes={today.sleep.coreMinutes}
          awakeMinutes={today.sleep.awakeMinutes}
        />
      </Card>

      <Card title="Detalle" subtitle="Comparado con tu baseline personal">
        <div className="metric-grid">
          <MetricRow
            label="Duracion total"
            value={formatMinutesAsHours(today.sleep.totalMinutes)}
            baseline={baselines.metrics.sleepDuration?.[30]}
            series={durationSeries}
          />
          <MetricRow
            label="Eficiencia"
            value={String(today.sleep.efficiency)}
            unit="%"
            baseline={baselines.metrics.sleepEfficiency?.[30]}
            series={efficiencySeries}
          />
          <MetricRow
            label="Sueno profundo"
            value={String(Math.round(today.sleep.deepMinutes))}
            unit="min"
            baseline={baselines.metrics.deepSleep?.[30]}
            series={deepSeries}
          />
          <MetricRow
            label="Sueno REM"
            value={String(Math.round(today.sleep.remMinutes))}
            unit="min"
            baseline={baselines.metrics.remSleep?.[30]}
            series={remSeries}
          />
          <MetricRow label="Latencia" value={String(Math.round(today.sleep.latencyMinutes))} unit="min" hideBaseline />
          <MetricRow label="Despertares" value={String(today.sleep.awakenings)} hideBaseline />
        </div>
      </Card>
    </div>
  );
}
